// extracted by mini-css-extract-plugin
export var bodySections = "_5v-8";
export var gray = "_5v-7";
export var green = "_5v-4";
export var iconContainer = "_5v-9";
export var iconWidgetContainer = "_5v-1";
export var phoneIcon = "_5v-2";
export var red = "_5v-5";
export var statusDot = "_5v-3";
export var widgetContainer = "_5v-0";
export var yellow = "_5v-6";